import { GraphQLResult } from 'aws-amplify/api';
import { UpdateCaseClusterMutation, UpdateCaseClusterMutationVariables } from '@/services/API';
import { updateCaseCluster } from '@/services/graphql/mutations';
import { callGraphQLApi } from '@/utils/graphQLAPI';

export const mutationUpdateCaseCluster = async (variables: UpdateCaseClusterMutationVariables) => {
  await callGraphQLApi<GraphQLResult<UpdateCaseClusterMutation>>(updateCaseCluster, variables);
};
